export const environment = {
    identityUrl: "https://stageapi.cashoutnow.app/auth",
    apiUrl: "https://api.stagebo.cashoutnow.app",
    boUrl: "https://stagebo.cashoutnow.app",
    userApiUrl: "https://stageapi.cashoutnow.app",
    userTrackingUrl: "https://playcharge.g2afse.com/click?pid={pid}&offer_id={offerId}",
    version: "0.1",
    name: "STAGE",
    appName: "Cashout Now",
    icon: "assets/icons/iconCON.png"
};
